import { Wrapper } from './fraudDefense.styles'
import { TopSection } from './topSection'
import { TAB_LIST } from './utils/utils'
import { IntegrationsStore } from '@/core/store/Integrations'
import { FraudDefenseMarketing } from './FraudDefenseMarketing'
import { FraudDefenseLoading } from './FraudDefenseLoading'
import TabsRouting from '@/ui/components/tabs-routing'
import { TabsContainer } from '@/ui/components/tabs-routing/index.styles'
import { Outlet } from 'react-router-dom'

const FraudDefensePage = () => {
    const { loading, lastFetched, error } = IntegrationsStore.useStore()

    const msFdActiveIntegrations =
        IntegrationsStore.getActiveIntegrationsByType('ms_fraud_defense')
    const googleFdActiveIntegrations =
        IntegrationsStore.getActiveIntegrationsByType('google_fraud_defense')
    const isMsIntegrationActive = msFdActiveIntegrations.length > 0

    const isGoogleIntegrationActive = googleFdActiveIntegrations.length > 0

    const isFdIntegrationEnabled =
        isGoogleIntegrationActive || isMsIntegrationActive

    const isFdBroken = IntegrationsStore.isFDBroken()

    if (loading || (!lastFetched && !error)) {
        return <FraudDefenseLoading />
    }

    if (isFdIntegrationEnabled || isFdBroken) {
        return (
            <>
                <TopSection />
                <TabsContainer>
                    <TabsRouting
                        tabList={TAB_LIST}
                        tabsName="fraud-defense-tab"
                    />
                </TabsContainer>
                <Outlet />
            </>
        )
    }

    return (
        <Wrapper>
            <FraudDefenseMarketing />
        </Wrapper>
    )
}

export default FraudDefensePage
